import { css, makeStyles } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  containerWrapper: theme => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: ${theme.spacing.md};
  `,

  containerBox: theme => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    gap: ${theme.spacing.xxs};
    span {
      font-weight: ${theme.fontWeights.bold};
    }
  `,

  loading: theme => css`
    animation: is-rotating 1s infinite;
    border: 10px solid ${theme.colors.neutral[100]};
    border-radius: 50%;
    border-top-color: ${theme.colors.brand.primary[300]};
    height: 79px;
    width: 79px;
    @keyframes is-rotating {
      to {
        transform: rotate(1turn);
      }
    }
  `,

  footer: theme => css`
    margin-top: ${theme.spacing.xs};
  `,
})

export { useStyles }
